const controlISI = () => {
    let footerEl = document.querySelector('.expandable-footer');
    let isSmallScreen = window.innerWidth < 992;
    let targetPosition = 0;

    // Note: The selectors here were already native in the snippet, kept as-is for compatibility. 
    // We add null checks to prevent errors if elements aren't found.
    let navbarHeight = 0;
    
    try {
        if (isSmallScreen) {
            const mobileNav = document.querySelector('.navbar-fixed-top.hidden-md.hidden-lg');
            navbarHeight = mobileNav ? mobileNav.getBoundingClientRect().height : 0;
        } else {
                // Selector handles union logic, querySelector returns first match found among them
            const desktopNav = document.querySelector('.navbar-fixed-top.hidden-xs.hidden-sm, .navbar-fixed-top .hidden-xs.hidden-sm');
            navbarHeight = desktopNav ? desktopNav.getBoundingClientRect().height : 0;
        }

        targetPosition = (footerEl.offsetTop - navbarHeight - 15);


    } catch (e) {
        console.error('Error calculating offset:', e);
    }

    targetPosition = (footerEl.offsetTop - navbarHeight - 15);


    /*
    const actionISI = () => {
        footerEl = document.querySelector('.expandable-footer');
        isSmallScreen = window.innerWidth < 992;

        // Note: The selectors here were already native in the snippet, kept as-is for compatibility. 
        // We add null checks to prevent errors if elements aren't found.
        let navbarHeight = 0;
        
        try {
            if (isSmallScreen) {
                const mobileNav = document.querySelector('.navbar-fixed-top.hidden-md.hidden-lg');
                navbarHeight = mobileNav ? mobileNav.getBoundingClientRect().height : 0;
            } else {
                    // Selector handles union logic, querySelector returns first match found among them
                const desktopNav = document.querySelector('.navbar-fixed-top.hidden-xs.hidden-sm, .navbar-fixed-top .hidden-xs.hidden-sm');
                navbarHeight = desktopNav ? desktopNav.getBoundingClientRect().height : 0;
            }

            let targetPosition = (footerEl.offsetTop - navbarHeight - 15);


        } catch (e) {
            console.error('Error calculating offset:', e);
        }
    }
        */

    window.addEventListener('load', function () {
        const hash = window.location.hash;


        if (hash === '#isi') {         
            // Smooth scroll using native API instead of jQuery animate()
            console.log('scrollTo')
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    })


    // Helper function for state changes (reusable in click and load)
    const toggleFooterState = () => {
        const btnCollapse = document.querySelector('.btn-collapse');
        const btnExpand = document.querySelector('.btn-expand');

        if (footerEl && btnCollapse && btnExpand) {
            footerEl.classList.toggle('fullscreen');
            btnCollapse.classList.toggle('hidden');
            btnExpand.classList.toggle('hidden');
        }

        // Scroll up, scroll down as necessary
    };

    // 1. Button Click Listener
    const buttons = document.querySelectorAll('.isi-button, [href="#isi"]');
    buttons.forEach(button => {
        button.addEventListener('click', function () {
            console.log('ISI Expanded')
            toggleFooterState();
            // actionISI()
            
            // Optional: Update browser history URL if desired (matches common UX patterns for these triggers)
            window.history.pushState(null, null, '#isi'); 
            targetPosition = (footerEl.offsetTop - navbarHeight - 15);

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        });
    });

    // 2. Window Load Listener




    // --- Configuration & Selectors ---
    var footerContainer = document.querySelector(".expandable-footer");
    var innerFooterContent = document.querySelector(".expandable-footer-inner");
    var innerFooterButton = document.querySelector(".isi-button p");

    // Safety check: Stop if elements aren't found to prevent console errors
    if (!footerContainer || !innerFooterContent) return;

    /**
     * Helper function to get the current vertical scroll position
     * Ensures compatibility across different browsers (older IE, modern standards)
    
     
    function getCurrentScrollTop() {
        var d = document.documentElement; // documentElement < html >
        var b = document.body || 0;       // fallback
        
        if (!b && d.scrollTop !== null && !(d.clientHeight - window.innerHeight)) return (window.pageYOffset ? window.pageYOffset : d.scrollTop);

        return d.scrollTop + ((document.compatMode == "CSS1Compat") ? -24: 0) || b.scrollTop + (-24) + (Math.round((footerContainer.getBoundingClientRect().top)));
    } 
    */
    
    // Simplified Modern Scroll Position Logic 
    function getScrollY() {
       return window.scrollY || document.documentElement.scrollTop; 
    }

    /**
     * Main logic to toggle the 'fixed' class based on scroll position
    */ 

    var handleStickyFooter = function () {
        // 1. Calculate where the footer is located relative to the top of the page
        var footerOffsetTop = footerContainer.getBoundingClientRect().top + getScrollY();

        // 2. Calculate Viewport Height (Max of client height and window innerHeight)
        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        // 3. Define the threshold point where behavior should switch 
        // Original logic: a = s - r
        var stickyThreshold = footerOffsetTop - viewportHeight;

        // 4. Get current scroll position (with original 100px offset buffer)
        var currentScrollPosWithBuffer = getScrollY() - 100; 

        const footerEl = document.querySelector('.expandable-footer');
        const btnCollapse = document.querySelector('.btn-collapse');
        const btnExpand = document.querySelector('.btn-expand');

        // 5. Apply class logic: 
        // If Scroll > Threshold -> Remove "fixed" (Normal state)
        // Else -> Add "fixed" (Sticky/Pinned state)
        if (currentScrollPosWithBuffer >= stickyThreshold) {
            // innerFooterContent.className = "";
            // innerFooterButton.textContent = "Click to collapse"
            footerEl.classList.add('fullscreen');
            btnCollapse.classList.remove('hidden');
            btnExpand.classList.add('hidden');
        } else {
            // innerFooterContent.className = "fixed";
            // innerFooterButton.textContent = "Click to expand"
            footerEl.classList.remove('fullscreen');
            btnCollapse.classList.add('hidden');
            btnExpand.classList.remove('hidden');
        }
    };

    /**
     * 1. Initialize immediately on load so the footer is correct before scrolling starts
    */
     
    handleStickyFooter(); 

    /** 
     * 2. Attach to Scroll Event (The original code was missing this!)
    */
     
    window.addEventListener('scroll', function() {
        // Throttling could be added here for performance on heavy sites, but raw JS keeps it simple:
        handleStickyFooter();
    }, false);
    

}

export { controlISI }